/* global G */
import { setKey } from '@gaia/util'
import { mergeMessages, sortMessages } from 'platform/adapter/message/helper'

/**
 * Sets or inserts messages into the adapter.
 *
 * If `insert` is truthy, it will merge the incoming with the incoming `items`
 * using `mergeMessages` and then sorted by `sortMessages`.
 *
 * If `insert` isn't truthy, the merge step is skipped and old items will
 * be disregarded.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 */
const fn = app => ({ detail }) => {
  const { [G.DATA]: items, [G.STATE]: { insert = false } = {} } = detail
  const { [G.EVENTS]: eventBus, [G.MESSAGE]: adapter } = app[G.ADAPTER]

  setKey(
    insert ? mergeMessages(adapter[G.DATA], items) : sortMessages(items),
    G.DATA,
    adapter,
  )

  eventBus.dispatch(
    eventBus.type(G.MESSAGE, G.DONE),
    { [G.DATA]: adapter[G.DATA] },
  )
}

export default fn
